import { Suspense, lazy } from 'react';

import type { Props as LottieProps } from './lottie';
import type { WithSlotProps } from '~/components/hocs';
import { withSlot } from '~/components/hocs';

const Lottie = lazy(() => import('./lottie'));

export const NAME = 'Lottie';

export interface Props extends React.PropsWithChildren, WithSlotProps, LottieProps {
  className?: string;
}

const LazyLottieComponent = (props: Props) => {
  const { animationData, loop, autoplay } = props;

  return (
    <Suspense fallback={null}>
      <Lottie animationData={animationData} loop={loop} autoplay={autoplay} />
    </Suspense>
  );
};

LazyLottieComponent.displayName = NAME;

export const LazyLottie = withSlot(LazyLottieComponent);
